import React from "react";
import Icon, { type IconProps } from "./Icon";
/** ArrowUp — Lucide. https://lucide.dev/icons/arrow-up (MIT). Copied 2026-05-16.
 *  Phase 3d: directional pairing with status colors (vs Target ahead, KPI
 *  delta positive). */
export default function ArrowUp(props: Omit<IconProps, "children">) {
  return (
    <Icon {...props}>
      <path d="m5 12 7-7 7 7" />
      <path d="M12 19V5" />
    </Icon>
  );
}
